class ContactDetails {

    constructor($attrs) {

        const setSubtype = contactModel => {
            this.subtype = (contactModel.subtype || {}).value;
        };

        this.$onInit = () => {
            if (this.contactModel) setSubtype(this.contactModel);
        };

        this.$onChanges = ({contactModel: {currentValue, previousValue}}) => {
            if (currentValue && currentValue !== previousValue) setSubtype(currentValue);
        };
        this.args = {contactModel: $attrs.contactModel};
    }
}

ContactDetails.$inject = ['$attrs'];

export default ContactDetails;
